export const adminTheme = {
    colors: {
        bg: "#020617",
        card: "#0f172a",
        hover: "#0f172a",
        header: "#020617",
        border: "rgba(255,255,255,0.08)",

        primary: "#020d1f",
        primaryHover: "#0891b2",

        success: "#22c55e",
        danger: "#dc2626",
        warning: "#f59e0b",

        text: "#22c55e",
        muted: "#94a3b8",
    },

    spacing: {
        xs: 6,
        sm: 10,
        md: 16,
        lg: 24,
    },

    radius: {
        sm: 6,
        md: 10,
        lg: 14,
    },
};

